import QueryWhereRules from './query-where-rules';
import { types } from '~/components/query/query-editor/query-editor.controller';
import QueryWhereNode from './query-where-node';
import QueryHaving from './query-having';

/** @type {Record<string,string>} */
export const defaultFieldByType = {
	boolean: 'kid',
	datetime: 'repre',
	file: 'repre',
	number: 'repre',
	string: 'kid',
};

export default class QueryWhereRule {
	/** @type {?QueryWhereNode | 'self'} */
	#node = null;

	/**
	 * @param {any} rule
	 * @param {?QueryWhereNode | 'self'} node
	 */
	constructor(rule = null, node = null) {
		this.#node = node;

		/** @type {string | undefined} */
		this.attribut = rule?.attribut;

		/** @type {'AND' | 'OR' | undefined } */
		this.condition = rule?.condition;

		let defaultField = 'kid';
		if (node instanceof QueryWhereNode && node.type in types) {
			defaultField = defaultFieldByType[types[node.type]];
		}

		/** @type {'attribut'|'datecreation'|'dated'|'datef'|'file'|'isa'|'kid'|'ref_propri'|'repre'} */
		this.field = rule?.field === undefined ? defaultField : rule.field;

		/** @type {import('./query-having').default | undefined} */
		this.having = rule?.having ? new QueryHaving(rule.having) : undefined;

		/** @type {import('@knitiv/api-client-javascript').KNodeOptional | undefined} */
		this.lang_kid = rule?.lang_kid;

		/** @type {string | undefined} */
		this.operator = rule?.operator;

		/** @type {?QueryWhereRules} */
		this.rules = rule?.rules ? new QueryWhereRules(rule.rules, node) : null;

		/** @type {any} */
		this.value = rule?.value;

		/** @type {any} */
		this.variable = rule?.variable;
	}

	isNodeRule() {
		return true;
	}

	/**
	 * @returns {?QueryWhereNode | 'self'} node
	 */
	getNode() {
		return this.#node;
	}

	/**
	 * @param {?QueryWhereNode | 'self'} node
	 */
	setNode(node) {
		this.#node = node;
	}

	/**
	 * @returns {boolean}
	 * TODO: improve this with node === 'self'
	 */
	isDateRange() {
		return this.#node instanceof QueryWhereNode && this.#node?.type === 'K_NODE;DATE'
			&& (
				this.value?.unit !== undefined
				|| (Array.isArray(this.value) && this.value.length > 0 && this.value[0]?.unit !== undefined)
			);
	}
}
